import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ViewCount' })({
    container: {
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        fontSize: 10,
        fontWeight: 600,
        lineHeight: '16px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase'
    },
    primary: {
        color: '#5F5F5F'
    },
    secondary: {
        color: '#8E8E8E'
    },
    _underline: {
        textDecoration: 'underline'
    }
});
